import { ApiError } from "../net/api";
import { describeError } from "./errors";

export const CODE_LENGTH = 6;
export const RESEND_SECONDS = 60;

/** Keeps the digits of whatever was typed or pasted ("123 456", "123-456", full-width "１２３", a whole sentence), at most six. */
export function normalizeCode(raw: string): string {
  return raw.replace(/[\uFF10-\uFF19]/g, (c) => String.fromCharCode(c.charCodeAt(0) - 0xff10 + 0x30)).replace(/\D/g, "").slice(0, CODE_LENGTH);
}

/** Seconds until "resend" may be pressed again, given when the last code was requested (ms). */
export function resendLeft(sentAt: number, now: number): number {
  return Math.max(0, Math.ceil((sentAt + RESEND_SECONDS * 1000 - now) / 1000));
}

/** The message for a failed login request; RATE_LIMITED says how long to wait when the server told us. */
export function loginError(err: unknown): string {
  if (!(err instanceof ApiError)) return "無法連線到伺服器";
  if (err.code === "RATE_LIMITED" && err.retryAfter > 0) return `嘗試太頻繁，請 ${err.retryAfter} 秒後再試`;
  return describeError(err.code);
}
